import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';
import SwaggerUI from 'swagger-ui-dist/swagger-ui-bundle.js';
import 'swagger-ui-dist/swagger-ui.css';
import { PageHeader } from '@/components/page-header';

export const Route = createFileRoute('/_app/docs')({
  component: DocsPage,
});

/**
 * Swagger UI over `/api/openapi.json`, which the API builds for the viewer's
 * role: each person sees only the endpoints they can call. Not linked from the
 * navigation on purpose; people open `/docs` directly.
 */
function DocsPage() {
  const host = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!host.current) return;
    SwaggerUI({
      domNode: host.current,
      url: '/api/openapi.json',
      deepLinking: true,
      docExpansion: 'none',
      defaultModelsExpandDepth: -1,
      persistAuthorization: false,
      // Same origin: the session cookie goes with every request, including Try it out.
      requestInterceptor: (req) => ({ ...req, credentials: 'same-origin' }),
    });
  }, []);

  return (
    <>
      <PageHeader title="API docs" />
      {/* Swagger UI has no dark theme, so it keeps a light surface of its own. */}
      <div className="rounded-lg border bg-white p-2 text-black">
        <div ref={host} />
      </div>
    </>
  );
}
